import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ButtonModule } from 'shared/button/button.module';
import { NavModule } from 'shared/nav/nav.module';
import { IconModule } from 'shared/icon/icon.module';
import { PaginationModule } from 'shared/pagination/pagination.module';

import { SegmentsNavigationComponent } from './segments-navigation/segments-navigation.component';
import { SegmentsNavigationV2Component } from './segments-navigation-v2/segments-navigation-v2.component';


@NgModule({
  imports: [
    CommonModule,
    ButtonModule,
    NavModule,
    IconModule,
    PaginationModule,
  ],
  declarations: [
    SegmentsNavigationComponent,
    SegmentsNavigationV2Component,
  ],
  exports: [
    SegmentsNavigationComponent,
    SegmentsNavigationV2Component,
  ],
  providers: []
})
export class SegmentsNavigationModule {}
